import { DateRangeRounded } from "@mui/icons-material";
import { Button } from "controls";
import { Dialog } from "layout";
import React, { useState } from "react";
import DateRangeForm from "./DateRangeForm";
import { formatDate } from "hooks";

const DynamicDateRange = ({ setFilterVal, filterVal, allowAll, className }) => {
  const [showForm, setShowForm] = useState(false);

  const handleShowForm = () => {
    setShowForm(!showForm);
  };

  return (
    <div className={`w-full ${className}`}>
      <Button
        onClick={handleShowForm}
        variant="text"
        fullWidth
        className="bg-white border !text-gray-600 !font-medium flex !justify-between h-full !px-[12px]"
        endIcon={<DateRangeRounded className="!text-gray-500" />}
      >
        {filterVal.type === 1
          ? "All time"
          : `${formatDate(filterVal.fromDate, "DD MMM, YYYY")} to 
        ${formatDate(filterVal.toDate, "DD MMM, YYYY")}`}
      </Button>

      {showForm && (
        <Dialog show={showForm} onClose={false} maxWidth="xs">
          <DateRangeForm
            {...{ setShowForm, setFilterVal, filterVal, allowAll }}
          />
        </Dialog>
      )}
    </div>
  );
};

export default DynamicDateRange;
